var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SvgComponent",
    {
      attrs: { width: "16", height: "16", fill: "none", viewBox: "0 0 16 16" },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3.53984 7.17445C5.48541 3.7249 6.4582 2.00012 7.9987 2.00012C9.5392 2.00012 10.512 3.7249 12.4576 7.17445L12.7 7.6043C14.3168 10.4709 15.1251 11.9041 14.3945 12.9521C13.6639 14.0001 11.8563 14.0001 8.24114 14.0001H7.75626C4.14107 14.0001 2.33348 14.0001 1.60287 12.9521C0.872259 11.9041 1.68064 10.4709 3.2974 7.6043L3.53984 7.17445ZM7.9987 4.83346C8.27484 4.83346 8.4987 5.05731 8.4987 5.33346V8.66679C8.4987 8.94293 8.27484 9.16679 7.9987 9.16679C7.72256 9.16679 7.4987 8.94293 7.4987 8.66679V5.33346C7.4987 5.05731 7.72256 4.83346 7.9987 4.83346ZM7.9987 11.3335C8.36689 11.3335 8.66536 11.035 8.66536 10.6668C8.66536 10.2986 8.36689 10.0001 7.9987 10.0001C7.63051 10.0001 7.33203 10.2986 7.33203 10.6668C7.33203 11.035 7.63051 11.3335 7.9987 11.3335Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }